import React from 'react';
import { beautifyNumber } from '../../../../Utils/FormatNumber';

const AccumulatedAdvancePanel = ({ t, accumulatedAdvance }) => {
    if (!accumulatedAdvance) return null;

    const items = [
        { label: t("המחזור העסקי"), value: accumulatedAdvance.incomesNoVats },
        { label: t("IncomeTaxAdvancesDifference"), value: accumulatedAdvance.total },
        { label: t("AcceptedWithholdingTax"), value: accumulatedAdvance.acceptedWithholdingTax, negative: true },
        { label: t("TotalDifference"), value: accumulatedAdvance.incomeTaxAdvances, isTotal: true },
    ];

    return (
        <div className="wht-accumulated-panel">
            <div className="wht-accumulated-panel__title">
                {t("AccumulatedDifferenceInAdvances")}
            </div>
            <div className="wht-accumulated-panel__items">
                {items.map((item, idx) => (
                    <div key={idx} className={`wht-accumulated-panel__item ${item.isTotal ? 'wht-accumulated-panel__item--total' : ''}`}>
                        <span className="wht-accumulated-panel__label">{item.label}</span>
                        <span className={`wht-accumulated-panel__value ${(item.value >= 0 && !item.negative) ? 'positive' : 'negative'}`}>
                            {item.negative ? `(${beautifyNumber(item.value)})` : beautifyNumber(item.value)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccumulatedAdvancePanel;
